/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsCareersListData } from './hosports-careers-list.data';
import { IHosportsCareersListProps } from './hosports-careers-list.props.autogenerated';

export interface IHosportsCareersListViewProps extends IHosportsCareersListProps<IHosportsCareersListData> {

}

/**
 *
 * Hosports1ColumnBanner component
 * @extends {React.PureComponent<IHosportsCareersListProps<IHosportsCareersListData>>}
 */
class HosportsCareersList extends React.PureComponent<IHosportsCareersListProps<IHosportsCareersListData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsCareersList;
